const alphabet = "abcdefghiljklmnopqrstuvxyzåäö";

export const getLetterByIndex = (index, uppercase = false) => {
	const char = alphabet.charAt(index);
	return (uppercase && char.toLocaleUpperCase()) || char;
};
